export default {
  local: 'http://api.affctrl.test',
  test: 'https://affiliatecontrol-api-dev.com',
  production: 'https://affiliatecontrol-api.com',
};
